__webpack_require__.p = "/assets/oralb-moneyback/dist/";